import React from 'react'
import { useTranslation } from 'react-i18next'
import { SectionShell } from '../shared/SectionShell'

const STEPS = [
    { tKey: 's1', dKey: 'd1', num: '01' },
    { tKey: 's2', dKey: 'd2', num: '02' },
    { tKey: 's3', dKey: 'd3', num: '03' },
]

export default function ThinkingSection() {
    const { t } = useTranslation()

    return (
        <SectionShell id="thinking">
            <div className="section-head">
                <span className="section-num">05</span>
                <span className="section-label">{t('thinking.label')}</span>
            </div>

            <div className="thinking-row">
                {STEPS.map(({ tKey, dKey, num }, i) => (
                    <React.Fragment key={tKey}>
                        <div className="thinking-node">
                            <div className="thinking-disc">
                                <span className="thinking-disc-num">{num}</span>
                            </div>
                            <h3 className="thinking-node-title">{t(`thinking.${tKey}`)}</h3>
                            <p className="thinking-node-desc">{t(`thinking.${dKey}`)}</p>
                        </div>
                        {i < STEPS.length - 1 && (
                            <div className="thinking-connector" aria-hidden="true">
                                <span className="thinking-arrow">→</span>
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </SectionShell>
    )
}
